import { render, staticRenderFns } from "./thresholds-table.vue?vue&type=template&id=4bbf7988"
import script from "./thresholds-table.vue?vue&type=script&lang=ts"
export * from "./thresholds-table.vue?vue&type=script&lang=ts"
import style0 from "./thresholds-table.vue?vue&type=style&index=0&id=4bbf7988&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bbf7988')) {
      api.createRecord('4bbf7988', component.options)
    } else {
      api.reload('4bbf7988', component.options)
    }
    module.hot.accept("./thresholds-table.vue?vue&type=template&id=4bbf7988", function () {
      api.rerender('4bbf7988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/thresholds-tab/thresholds-table/thresholds-table.vue"
export default component.exports